import React from 'react';
import { g as getCompoundComponent } from './DataList.utils-CKHBAG6U.js';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';

// This component is meant to capture the props of the DataList.Filters
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function DataListStatusBar(_) {
    return null;
}
/**
 * Renders the DataList.StatusBar component
 */
function InternalDataListStatusBar() {
    const { children: parentChildren } = useDataListContext();
    const component = getCompoundComponent(parentChildren, DataListStatusBar);
    if (!component)
        return null;
    const children = component === null || component === void 0 ? void 0 : component.props.children;
    return React.createElement(React.Fragment, null, children);
}

export { DataListStatusBar as D, InternalDataListStatusBar as I };
